function initProjectPage() {
  
  var Page_project_template_filter_slider = document.querySelector('.Page_project_template_filter_slider');

  if (Page_project_template_filter_slider) {
      new Swiper('.Page_project_template_filter_slider', {
          loop: false,
          grabCursor: false,
          spaceBetween: 10,
          slidesPerGroup: 1,
          slidesPerView: "auto",
          watchSlidesProgress: true,
          draggable: !0,
          autoHeight: !1,
          watchOverflow: !0,
          threshold: 10,
          mousewheel: {
              forceToAxis: !0
          },
          observer: true,
          observeParents: true,
          freeMode: !0,
          breakpoints: {
              0: {
                  freeMode: !1
              },
              750: {
              },
              990: {
              },
              1200: {
              },
              1440: {
              }
          }
      })
  }

  const Page_project_template_review_slider = document.querySelector('.Page_project_template_review_slider');

  if (Page_project_template_review_slider) {
      const swiper = new Swiper('.Page_project_template_review_slider', {
          loop: true,
          grabCursor: false,
          spaceBetween: 10,
          slidesPerGroup: 1,
          slidesPerView: 1,
          watchSlidesProgress: true,
          draggable: !0,
          autoHeight: !1,
          watchOverflow: !0,
          threshold: 10,
          mousewheel: {
              forceToAxis: !0
          },
          observer: true,
          observeParents: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          effect: "fade",
          speed: 300,
          fadeEffect: {
              crossFade: true,
          },
          on: {
              init: function () {
                  setTimeout(() => updateBulletColor(this), 0);
              },
              slideChange: function () {
                  updateBulletColor(this);
              }
          }
      });

      function updateBulletColor(swiper) {
          const realIndex = swiper.realIndex;
          const slide = swiper.slides.find(
            s => Number(s.getAttribute('data-swiper-slide-index')) === realIndex
          );

          const color = slide?.dataset.color;

          if (color) {
              swiper.pagination.bullets.forEach(bullet => {
                  bullet.style.backgroundColor = '';
                  bullet.style.border = `1px solid ${color}`;
              });

              const activeBullet = swiper.pagination.bullets[realIndex];
              if (activeBullet) {
                  activeBullet.style.backgroundColor = color;
                  activeBullet.style.border = `1px solid ${color}`;
              }
          }
      }
  }

  document.addEventListener("scroll", function () {
    const el = document.querySelector(".Project_mainpart_new");
    if (!el) return;

    const rect = el.getBoundingClientRect();

    const isSticky = rect.top <= 0;
    const isInViewport = rect.bottom > 0 && rect.top < window.innerHeight;

    if (isSticky && isInViewport) {
      document.body.classList.add("is-sticky");
    } else {
      document.body.classList.remove("is-sticky");
    }
  });

  const btn = document.querySelector(".open_filter");
  const closeBtn = document.querySelector(".close_filter");

  const overlay = document.querySelector(".Project_filter_overylay_new");
  const inner = document.querySelector(".Project_innerpart_mainitem_new");
  const spanText = btn.querySelector("span");

  btn.addEventListener("click", function () {
    overlay.classList.toggle("open");
    inner.classList.toggle("open");
    document.body.classList.toggle("body_open_filter");

    if (overlay.classList.contains("open")) {
      spanText.textContent = "close filters";
    } else {
      spanText.textContent = "project filters";
    }
  });

  closeBtn.addEventListener("click", function () {
    overlay.classList.remove("open");
    inner.classList.remove("open");
    document.body.classList.remove("body_open_filter");

    spanText.textContent = "project filters";
  });


  const container = document.querySelector(".Project_mainloop_new");
  const gridBtn = document.getElementById("gridView");
  const listBtn = document.getElementById("listView");

  if (container && gridBtn && listBtn) {

    // Set cookie
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 86400000));
      document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    // Get cookie
    function getCookie(name) {
      return document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))
        ?.split('=')[1];
    }

    // Apply view
    function setView(view) {
      const isList = view === "list";

      container.classList.toggle("Project_mainloop_list_new", isList);
      container.classList.toggle("Project_mainloop_grid_new", !isList);

      listBtn.classList.toggle("active", isList);
      gridBtn.classList.toggle("active", !isList);

      setCookie("viewMode", isList ? "list" : "grid", 7);
    }

    // Button events
    gridBtn.addEventListener("click", () => setView("grid"));
    listBtn.addEventListener("click", () => setView("list"));

    // ✅ Default to GRID if no cookie (first visit)
    const savedView = getCookie("viewMode");
    setView(savedView === "list" ? "list" : "grid");
  }

}

document.addEventListener("DOMContentLoaded", initProjectPage);